import {
    Button,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    useBreakpointValue,
    useColorModeValue
} from "@chakra-ui/react";
import React from "react";
import {BsArrowRight as BackArrowIcon} from "react-icons/bs";

import CombinedPolicies from "../CombinedPolicies/CombiniedPolicies";


function PoliciesDrawer({btnRef, onClose}) {

    const drawerSize = useBreakpointValue({base: "full", sm: "sm"})
    const ModalBG = useColorModeValue('#F9FAFA', '#3D3D3D')
    return (
        <Drawer
            isOpen
            placement='right'
            size={drawerSize}
            onClose={onClose}
            finalFocusRef={btnRef}

            portalProps={{
                appendToParentPortal: false
            }}
        >
            <DrawerOverlay zIndex='1400'/>
            <DrawerContent bg={ModalBG}>
                <DrawerCloseButton/>
                <DrawerHeader>Policies and Terms & Conditions</DrawerHeader>

                <DrawerBody>
                    <CombinedPolicies/>
                    <article>
                        <h1 className="heading">
                            {/* eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/anchor-is-valid */}
                            <a name="general_terms"/>
                            <a href="#general_terms">General Terms &amp; Conditions</a>
                        </h1>
                        <h1 className="highlighter">
                            Provider Indemnification
                        </h1>
                        <p className="message">
                            IN CONSIDERATION for participation in this event and other valuable consideration, I
                            hereby RELEASE, WAIVE, DISCHARGE AND CONVENANT NOT TO SUE , McMohawk LLC, Mohawk Area
                            Management LLC and their Board of Directors, officers, servants, agents, and employees
                            (hereinafter referred to the INDEMNITEES AND RELEASEES) and shall indemnify, defend and
                            hold harmless the INDEMNITEES AND RELEASEES and their officers, directors, agents and
                            employees, for claims arising out of or resulting from any and all liability, claims,
                            demands, actions and causes of action whatsoever arising out of or related to any loss,
                            damage, or injury, including death, that may be sustained by me, or to any property
                            belonging to me, WHETHER CAUSED BY THE NEGLIGENCE OF THE RELEASEES and INDEMNITEES, or
                            otherwise, while participating in such activity, or while in, on or upon the premises
                            where the activity is being conducted or in transportation to and from said premises.

                            To the best of my knowledge, I can fully participate in this activity. I am fully aware
                            of risks and hazards connected with the activity, including but not limited to the risks
                            as noted herein, and I hereby elect to voluntarily participate in said activity, and to
                            enter the above-named premises and engage in such activity knowing that the activity may
                            be hazardous to me and my property. I give my permission for the use of my name and
                            likeness to be used for informational and publicity purposes. I VOLUNTARILY ASSUME FULL
                            RESPONSIBILITY FOR ANY RISKS OF LOSS, PROPERTY DAMAGE OR PERSONAL INJURY, INCLUDING
                            DEATH, that may be sustained by me, or any loss or damage to property owned by me, as a
                            result of being engaged in such an activity, WHETHER CAUSED BY THE NEGLIGENCE OF
                            RELEASES or otherwise .

                            I further hereby AGREE TO INDEMNIFY AND HdOLD HARMLESS THE RELEASES from any loss,
                            liability, damage or costs, including court costs and attorney's fees, that may incur
                            due to my participation in said activity, WHETHER CAUSED BY NEGLIGENCE OF RELEASES or
                            otherwise.

                            It is my express intent that this Release and Hold Harmless Agreement shall bind the
                            members of my family and spouse (if any), if I am alive, and my heirs, assigns and
                            personal representative, if I am not alive, shall be deemed as a RELEASE, WAIVER
                            DISCHARGE AND COVENANT NOT TO SUE the above named RELEASES. I hereby further agree that
                            this Waiver of Liability and Hold Harmless Agreement shall be construed in accordance
                            with the laws of the State of Ohio

                            I UNDERSTAND THAT THE RELEASES and INDEMNITES WILL NOT BE RESPONSIBLE FOR ANY MEDICAL
                            COSTS ASSOCIATED WITH AN INJURY I MAY SUSTAIN.

                            I also understand that I should and am urged by Indemnite to obtain adequate health,
                            accident and liability insurance to cover any personal injury to myself or others which
                            may be sustained during the activity or the transportation to and from said activity.

                            IN AGREEING TO THIS RELEASE, I ACKNOWLEDGE AND REPRESENT THAT I have read the foregoing
                            Waiver of Liability and Hold Harmless Agreement, understand it and agree to it
                            voluntarily as my own free act and deed; no oral representations. statements or
                            inducements, apart from the foregoing written agreement, have been made; I am at least
                            eighteen (18) years of age and fully competent; and I execute this Release for full,
                            adequate and complete consideration fully intending to be bound by same.
                        </p>
                        <h1 className="highlighter">
                            Privacy Policy
                        </h1>
                        <p className="message">
                            BOUTIQUEMATE.COM (“BOUTIQUEMATE.COM” “we” “us” or “our”) provides users with the ability
                            to search for vacancies, book and pay for hotel reservations (the "Service" or the
                            customer "Requests") where such hotel services are provided by third-party affiliates of
                            Boutique Mate, LLC (the "Travel Service Providers"); the foregoing Service is provided
                            via our website at BOUTIQUEMATE.COM (the "Site").
                        </p>
                        <p className="message">
                            We are providing this Privacy Policy to inform you of our policies and procedures
                            regarding the collection, use, and disclosure of personal information we receive from
                            users of the Site.
                        </p>
                        <p className="message">
                            As used in this policy, the terms “using” and “processing” information include using
                            cookies on a computer, subjecting the information to statistical or other analysis and
                            using or touching information in any way, including, but not limited to collecting,
                            storing, evaluating, modifying, deleting, using, combining, disclosing and transferring
                            information within the United States or internationally.
                        </p>
                    </article>

                    <article>
                        <h1 className="highlighter">
                            Information Collection and Use
                        </h1>
                        <p className="message">
                            Our primary goals in collecting information are to provide and improve the Service,
                            features and content, to administer your membership and to enable users to enjoy and
                            easily navigate the Site. We also may also use your information in order to better
                            understand how the Service is used.
                        </p>
                        <p className="message">
                            In the course of using the Service, we ask you to provide us with certain personally
                            identifiable information that can be used to contact or identify you and administer your
                            account (“Personal Information”). Personal Information may include, but is not limited
                            to, your name, phone number, credit card or other billing information, email address and
                            home and business postal addresses. We use your Personal Information mainly to provide
                            the Service and administer your inquiries. We also collect certain financial data which
                            is used for the purpose of processing or completing the financial transactions of your
                            orders ("Financial Data"). Financial Data may include your credit card number,
                            expiration date, and verification code. We use Financial Data solely for the purpose of
                            processing your orders and, as such, your Financial Data is only shared with necessary
                            third-parties, such as financial institutions, credit card merchants, and vendors of
                            your ordered services for the sole purpose of processing your orders.
                            <br/>
                            Please be aware that when you register on our Site, other users of the Service may be
                            able to see your screen or user name, in addition to any comments or submissions that
                            you post to the Site or submit via the Service. We recommend that you guard your
                            anonymity and sensitive information and that you not use your real name as your screen
                            or user name to the extent that allows others to identify you. Your Personal Information
                            may be shared with law enforcement and other third parties in accordance with this
                            Privacy Policy and subject to all applicable laws.
                            <br/>
                            We also collect the other information that you provide as part of your use of the
                            Service, including via your registration and the administration and personalization of
                            your profile webpage (e.g., without limitation zip code, gender, age and individual
                            preferences) (“Non-Identifying Information”). Certain Non-Identifying Information would
                            be considered a part of your Personal Information if it were combined with other
                            identifiers (for example, combining your zip code with your street address) in a way
                            that enables you to be identified. But the same pieces of information are considered
                            Non-Identifying Information when they are taken alone or combined only with other
                            non-identifying information (for example, your viewing preferences). We may combine your
                            Personal Information with Non-Identifying Information and aggregate it with information
                            collected from other users of the Service to attempt to provide you with a better
                            experience, to improve the quality and value of the Service and to analyze and
                            understand how the Service is used.
                            <br/>
                            We may also use your Personal Information to contact you with marketing or
                            promotional materials and other information that may be of interest to you.
                            <br/>
                            We may also share and use your Personal Information with other networks,
                            websites and entities affiliated, owned, controlled and/or connected with
                            BOUTIQUEMATE.COM. We will use your Personal Information in compliance with the
                            terms of this Privacy Policy.
                            <br/>
                            If BOUTIQUEMATE.COM sells all or part of this Site or makes a sale or
                            transfer of assets or is otherwise involved in a merger or business
                            transfer, we may, in our sole discretion, transfer, sell or assign your
                            Personal Information to a third party as part or in connection with that
                            transaction. Upon such transfer, the Privacy Policy of the acquiring entity
                            may govern the use of your Personal Information.
                            <br/>
                            Information posted to message boards, chat rooms, blogs and other user
                            forums become public information. Use caution when posting. Individuals
                            under the age of 18 should use additional care not to provide any personally
                            identifying information when participating in any area of the Site where
                            postings might become public.
                        </p>
                    </article>

                    <article>
                        <h1 className="highlighter">
                            Cookies
                        </h1>
                        <p className="message">
                            As you interact with the Site, we collect certain Site use information. This information
                            is collected for all users. When you enter the Site, we collect your IP address and
                            browser type. In addition, we store certain information from your browser using cookies.
                            A cookie is a small data file that is stored by your web browser on your computer. The
                            cookies we use include, without limitation, session ID cookies and persistent cookies.
                            This data may be used for security purposes, to track usage and to manage and improve
                            the Site. Cookies also allow us to enhance, personalize and track your online
                            experience, so that the information you receive is more relevant to you. This technology
                            will allow you to move faster through our Site once the information is in our database
                            since you do not have to re-enter the same information each time you enter the Site.
                            Session ID cookies confirm that you are logged in. These cookies terminate once you
                            close your browser. Persistent cookies store your login ID (but not your password) to
                            make it easier for you to login when you come back to the Site. If you prefer, you can
                            set your browser to refuse cookies or to alert you when cookies are being sent; however,
                            it is possible that some parts of the Service will not function properly if you do.
                        </p>
                    </article>


                    <article>
                        <h1 className="highlighter">
                            Legal Considerations
                        </h1>
                        <p className="message">
                            On rare occasions, we may disclose specific information upon governmental request, in
                            response to a subpoena or court order, or when required by law to do so. Additionally,
                            we may share account or other information when we believe it is necessary to comply with
                            law, to protect our interests or property, to report and/or prevent fraud or other
                            illegal activity perpetrated through the Site, or to prevent imminent bodily harm. This
                            may include sharing information with other companies, lawyers, agents or government
                            agencies. We may also share information with companies assisting in fraud protection or
                            investigation. We do not provide information to these agencies or companies for
                            marketing or commercial purposes.
                        </p>
                    </article>

                    <article>
                        <h1 className="highlighter">
                            Third Party Advertising
                        </h1>
                        <p className="message">
                            Advertisements that appear on the Site are sometimes delivered directly to users by
                            third party advertisers. The third party advertiser will automatically receive your IP
                            address when this happens. These third party advertisers may also download cookies to
                            your computer, or use other technologies such as JavaScript and "web beacons" (also
                            known as "1x1 gifs") to measure the effectiveness of their ads and to personalize
                            advertising content. Doing this allows the advertising network to recognize your
                            computer each time they send you an advertisement in order to measure the effectiveness
                            of their ads and to personalize advertising content. In this way, they may compile
                            information about where individuals using your computer or browser saw their
                            advertisements and determine which advertisements are clicked. BOUTIQUEMATE.COM does not
                            have access to or control of the cookies that may be placed by the third party
                            advertisers. Third party advertisers have no access to your contact information stored
                            on the Site unless you choose to share it with them. This Privacy Policy covers the use
                            of cookies by BOUTIQUEMATE.COM on the Site and does not cover the use of cookies or
                            other tracking technologies by any of its advertisers.
                        </p>
                    </article>


                    <article>
                        <h1 className="highlighter">
                            Changing or Deleting your Information
                        </h1>
                        <p className="message">
                            At any time, you may review, update, correct or delete the Personal Information in your
                            registration profile by contacting us. If you completely delete all such information,
                            then your account may become deactivated. If you would like us to delete your record in
                            our system, please contact us and we will attempt to accommodate your request. See below
                            for privacy contact information.
                        </p>
                    </article>


                    <article>
                        <h1 className="highlighter">
                            Security
                        </h1>
                        <p className="message">
                            At any time, you may review, update, correct or delete the Personal Information in your
                            registration profile by contacting us. If you completely delete all such information,
                            then your account may become deactivated. If you would like us to delete your record in
                            our system, please contact us and we will attempt to accommodate your request. See below
                            for privacy contact information.
                        </p>
                    </article>


                    <article>
                        <h1 className="highlighter">
                            Our Policy Toward Children
                        </h1>
                        <p className="message">
                            We do not knowingly collect personally identifiable information from children under the
                            age of 14. If a parent or guardian becomes aware that his or her child has provided us
                            with Personal Information without their consent, he or she should contact us at
                            legal@boutiquemate.com. If we become aware that a child under the age of 14 has provided
                            us with Personal Information, we will delete such information from our files.
                        </p>
                    </article>


                    <article>
                        <h1 className="highlighter">
                            Contacting Us
                        </h1>
                        <p className="message">
                            If you have any questions about this Privacy Policy, please contact us at
                            legal@boutiquemate.com or at:
                            <br/>Legal Department
                            <br/>Boutique Mate, LLC
                            <br/>244 Madison Avenue
                            <br/>P.O. Box # 4140
                            <br/>New York, NY 10016
                        </p>
                    </article>

                    <article>
                        <h1 className="highlighter">
                            Policy Changes
                        </h1>
                        <p className="message">
                            From time to time, we may use your information for unanticipated uses not previously
                            disclosed in our privacy notice. If our information practices change, we will post these
                            changes in the Site. We encourage you to review our Privacy Policy periodically.
                        </p>
                    </article>


                    <article>
                        <h1 className="highlighter">
                            Your Consent
                        </h1>
                        <p className="message">
                            By using the Site or by continuing to use the Service, you consent to the collection and
                            use of your information as detailed in this Privacy Policy.
                        </p>
                    </article>


                    <article>
                        <h1 className="highlighter">
                            Terms of Service, Privacy Policy, Notices and Revisions
                        </h1>
                        <p className="message">
                            Your use of the Site, and any disputes arising from it, are subject to this Privacy
                            Policy and our Terms & Conditions and all of its dispute resolution provisions including
                            limitation on damages and choice of law. We reserve the right to change our Privacy
                            Policy and our Terms & Conditions any time. All changes and clarifications will take
                            effect immediately, upon their posting on this Site. If we make changes, we will post
                            them and will indicate on the applicable policy or agreement the new effective date. We
                            encourage you to refer to this policy on an ongoing basis so that you understand our
                            current Privacy Policy.
                        </p>
                    </article>

                </DrawerBody>

                <DrawerFooter>
                    <Button width='100%' variant='outline' onClick={onClose} rightIcon={<BackArrowIcon/>}>
                        Back to Checkout
                    </Button>
                </DrawerFooter>
            </DrawerContent>
        </Drawer>
    )
}

export default PoliciesDrawer